import React, { useState } from 'react'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebase'
import { connect } from 'react-redux'
import { toast } from 'react-hot-toast'
import { notifyUser } from '../utils/notificationHelpers'

function AddComment(props) {
  const userId = localStorage.getItem("user_id")
  const [text, setText] = useState('')
  const [status, setStatus] = useState('idle') // idle | posting | posted

  async function postComment(e) {
    e.preventDefault()
    const commentText = text.trim()
    if (!commentText || status !== 'idle') return

    setStatus('posting')
    const comment = {
      user_id: userId,
      post_id: props.post_id,
      discussion_room: props.discussionroom,
      comment: commentText,
      created_at: serverTimestamp(),
    }

    try {
      const docRef = await addDoc(collection(db, 'postComments'), comment)
      if (props.onCommentPosted) {
        props.onCommentPosted({ id: docRef.id, ...comment, created_at: new Date() })
      }
      setStatus('posted')
    } catch (err) {
      console.error('Failed to post comment:', err)
      toast.error('Could not post your comment. Please try again.')
      setStatus('idle')
      return
    }

    // Notify the post author that someone responded (notifyUser skips self-replies)
    if (props.post_author_id) {
      const fromName = `${props.first_name || ''} ${props.last_name || ''}`.trim() || 'Someone'
      const snippet = commentText.length > 60 ? commentText.slice(0, 60) + '…' : commentText
      notifyUser({
        toUserId: props.post_author_id,
        fromUserId: userId,
        fromName,
        type: 'forum_comment',
        message: `${fromName} responded to your post in ${props.discussionroom}: "${snippet}"`,
        url: `/${props.discussionroom}`,
      })
    }

    // Let the "Posted ✓" confirmation show briefly before closing the box
    setTimeout(() => props.setViewAddComment(false), 1500)
  }

  if (status === 'posted') {
    return (
      <div className="addCommentBox">
        <p className="commentary-text" style={{ color: '#15803D', fontWeight: 'bold' }}>
          ✓ Posted
        </p>
      </div>
    )
  }

  const formId = `postcommentform-${props.post_id}`

  return (
    <div className="addCommentBox">
      <br />
      <form onSubmit={postComment} id={formId}>
        <textarea className="addComment"
          name="comment"
          form={formId}
          value={text}
          onChange={e => setText(e.target.value)}
          disabled={status === 'posting'}
          autoFocus>
        </textarea>
        <button id="bigbutton" type="submit" disabled={status === 'posting' || !text.trim()}>
          {status === 'posting' ? 'Posting…' : 'Post Comment'}
        </button>
        <br /><br />
      </form>
      <button id="bigbutton" type="button" onClick={() => props.setViewAddComment(false)}>Cancel</button>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    first_name: state.first_name,
    last_name: state.last_name
  }
}

export default connect(mapStateToProps)(AddComment)
